import { OctToastComponent } from "@components/oct-toast/oct-toast.component";
import { ToastService } from "@services/toast.service";

import { Component, inject } from "@angular/core";
import { RouterOutlet } from "@angular/router";

@Component({
  selector: "oct-root",
  imports: [RouterOutlet, OctToastComponent],
  template: `
    <oct-toast
      [type]="toastState().type"
      [compact]="toastState().compact"
      [header]="toastState().header"
      [content]="toastState().content"
      [askConfirmation]="toastState().askConfirmation"
      [shown]="toastState().shown"
      [confirmText]="toastState().confirmText"
      [cancelText]="toastState().cancelText"
      [top]="toastState().top"
      [width]="toastState().width"
      [personalizedContent]="toastState().personalizedContent"
      [templateRef]="toastState().templateRef"
      [templateContext]="toastState().templateContext"
      (acceptEvent)="toastService.respond(true)"
      (cancelEvent)="toastService.respond(false)" />
    <router-outlet />
  `,
})
export class AppComponent {
  toastService = inject(ToastService);
  toastState = this.toastService.toastState.asReadonly();
}
